module.exports = __webpack_public_path__ + "static/media/youtube.f82d2259.svg";